<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import Paginate from 'vuejs-paginate';
Vue.component('Paginate', Paginate);
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'Pagination',
  components: {
    Paginate,
  },
  props: {
    pages: {
      type: Number,
      required: true,
    },
    page: {
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    setPage(n) {
      this.$emit('set-page', n);
    },
  },
};
</script>

<template>
  <div class="pagination" v-if="pages > 1">
    <Paginate
      :page-count="pages"
      :click-handler="setPage"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :container-class="'pagination__wrapper'"
      :page-class="'pagination__item'"
      :prev-class="'pagination__item pagination__item--prev'"
      :next-class="'pagination__item pagination__item--next'"
    />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
::v-deep .pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 20px 0;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 30px;
    position: relative;
    padding: 0;

    &:before {
      content: '';
      position: absolute;
      top: -30px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 200px);
      min-width: 100px;
      height: 1px;
      background: rgba(151, 151, 151, 0.3);
    }
  }

  &__item {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 36px;
    color: rgba(255, 255, 255, 0.7);
    min-height: 36px;

    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 12px;

    &.disabled {
      pointer-events: none;
      user-select: none;
    }

    &:hover:not(disabled),
    &.active {
      color: #00b8f9;
      border-color: #00b8f9;
    }

    &--prev,
    &--next {
      min-width: 70px;
      color: #ffffff;
      a {
        padding: 5px 10px;
      }
    }

    &--prev {
      margin-right: 30px;
    }

    &--next {
      margin-left: 18px;
      margin-right: 0;
    }

    a {
      outline: none;
      border: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 5px;
    }
  }
}

/* mobile */
@media (max-width: $mobile) {
  ::v-deep .pagination {
    padding: 0;
    padding-top: 20px;

    &__wrapper {
      margin: 0 10px;

      &:before {
        width: 100px;
        left: 50%;
        transform: translateX(-50%);
        top: -20px;
      }
    }

    &__item {
      margin-top: 5px;
      margin-bottom: 5px;
      margin: 5px;
      a {
        padding: 5px 5px;
      }
      &--prev {
        margin-right: 15px;
      }

      &--next {
        margin-left: 10px;
        margin-right: 0;
      }
    }
  }
}
</style>
